import loadable from "@loadable/component"

export const NewsLoaded = loadable(() =>
  import(
    /* webpackChunkName: "adverts-chunk" */
    /* webpackPrefetch: true */
    "./News"
  ).then(mod => mod.News)
)
